import { HopperAssets as CDNHopperAssets } from "./cdn";
// import { HopperAssets as LocalHopperAssets } from "./local";

// Import bug for ESM imports: https://www.npmjs.com/package/deepmerge#include
// import * as deepmerge from "deepmerge";

export const HopperAssets = CDNHopperAssets;
// export const HopperAssets = deepmerge(CDNHopperAssets, LocalHopperAssets);
